/** 负1F 地址（接真实接口后替换 id；当前仅展示底图） */
export const B1_ADDRESS = {
  id: '',
  name: '负1F',
  display: '负1F'
}
